import { Course } from "../UseCases/Menu/Menu.types";
import { CourseData } from "../UseCases/Educations/Education.types";

export default function getCourseProgress(
  course: Course | null,
  userData?: UserData | null,
  courseData?: CourseData | null
): number {
  // Prefer courseData if available (more up-to-date)
  if (courseData && course?.ID === courseData.ID) {
    const highestLevelCompleted = courseData.highestLevelCompleted ?? -1;
    const numberOfLevels =
      courseData.adjustedNumberOfLevels ?? courseData.NumberOfLevels ?? 0;

    if (numberOfLevels > 0 && highestLevelCompleted >= 0) {
      let progress = (highestLevelCompleted + 1) / numberOfLevels;
      progress = Math.min(progress, 1);
      return Math.round(progress * 100);
    }
  }

  // Try to use course object directly if it has progress data
  // This is useful when course is a merged object with user-specific data
  const courseWithData = course as any;
  if (
    courseWithData?.highestLevelCompleted !== undefined &&
    courseWithData?.NumberOfLevels !== undefined
  ) {
    const highestLevelCompleted = courseWithData.highestLevelCompleted ?? -1;
    const numberOfLevels =
      courseWithData.adjustedNumberOfLevels ??
      courseWithData.NumberOfLevels ??
      0;

    if (numberOfLevels > 0 && highestLevelCompleted >= 0) {
      let progress = (highestLevelCompleted + 1) / numberOfLevels;
      progress = Math.min(progress, 1);
      return Math.round(progress * 100);
    }
  }

  // Fallback to userData
  const education = userData?.Educations?.find(
    (education) => education.ID === course?.ID
  );

  if (!education) {
    return 0;
  }

  // Calculate progress directly from highestLevelCompleted and NumberOfLevels
  // instead of using the cached Progress field, which may be incorrect if
  // highestLevelCompleted was manually changed after completion
  const highestLevelCompleted = education.highestLevelCompleted ?? -1;
  const numberOfLevels = education.NumberOfLevels ?? 0;

  // If no levels or invalid data, return 0
  if (numberOfLevels <= 0 || highestLevelCompleted < 0) {
    return 0;
  }

  // Calculate progress: (highestLevelCompleted + 1) / numberOfLevels
  // +1 because highestLevelCompleted is 0-indexed (0 = first level completed)
  let progress = (highestLevelCompleted + 1) / numberOfLevels;

  // Cap at 100%
  progress = Math.min(progress, 1);

  // Round to nearest integer percentage
  return Math.round(progress * 100);
}
